import { HeaderProvide } from "../headerProvide/HeaderProvider";

export default class HeaderProductCategories {
  static async AllHeaderProductCategories(lang: string = "az") {
    const res = await HeaderProvide.getHeaderProductCategories(lang);
    return res;
  }
  static async getOrderCategory(lang: string = "az") {
    const res = await HeaderProvide.getOrderCategory(lang);
    return res;
  }
  static async AllHeaderServices() {
    // const res = await HeaderProvide.getHeaderServices();
    // return res;
    return { data: { data: [] } };
  }
  static async getLanguegs() {
    const res = await HeaderProvide.getLanguages();
    return res;
  }

  static async getSearchProduct(
    searchKeyword: string,
    channel: string = "1688",
    page: number = 1,
    perPage: number = 24
  ) {
    const res = await HeaderProvide.getSearchProducts(
      searchKeyword,
      channel,
      page,
      perPage
    );
    return res;
  }

  static searchProductsByImage = async (
    file: File | Blob | string,
    channel: string = "1688",
    page: number = 1,
    perPage: number = 24,
    extraParams?: Record<string, any>
  ) => {
    const res = await HeaderProvide.searchProductsByImage(
      file,
      channel,
      page,
      perPage,
      extraParams
    );
    return res;
  };

  static async getFilterItems(id: number) {
    const res = await HeaderProvide.getFilterItems(id);
    return res;
  }
  static async getFilterData(payload: any) {
    const res = await HeaderProvide.getFilterData(payload);
    return res;
  }
  static async getPartnerProducts(params: { category_id?: number | string; page?: number; per_page?: number; [key: string]: any }) {
    const res = await HeaderProvide.getPartnerProducts(params);
    return res;
  }
}
